const eventsList = (state) => {
  return state.listData
}

const eventsListPagination = (state) => {
  return state.pagination
}

const totalEvents = state => {
  return state.totalEvents
}

const selectedEvent = (state) => {
  return state.selectedEvent
}

const selectedEventIndex = state => {
  return state.selectedEventIndex
}

export default {
  eventsList,
  totalEvents,
  eventsListPagination,
  selectedEvent,
  selectedEventIndex,
}
